<template>
  <v-container class="full-width pb-6 white-bg">
    <v-layout class="wrapper full-width">
      <v-row align="center" justify="center">
        <v-col cols="7" align="center" justify="center">
          <h1 class="mb-2">
            Experience both day and night with an ambient soundscape created
            just for you.
          </h1>
          <h1 class="mb-5">
            The music features original sounds from the surrounding nature in
            Brandenburg and even contains a few precious bird voices. So close
            your eyes and let us take you to the marshlands of Brandenburg.
          </h1>
          <div style="display: flex; flex-direction: column" align="center">
            <v-btn
              rounded
              outlined
              class="download-btn mt-6"
              @click="downloadDay"
              ><p>download day theme</p></v-btn
            >
            <v-btn
              rounded
              outlined
              class="download-btn mt-6"
              @click="downloadNight"
              ><p>download night theme</p></v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Download",
  methods: {
    downloadDay() {
      const link = document.createElement("a");
      link.href = require("../assets/theme_day.mp3");
      link.setAttribute("download", "Birdwatcher Day Theme.mp3");
      link.click();
    },
    downloadNight() {
      const link = document.createElement("a");
      link.href = require("../assets/theme_night.mp3");
      link.setAttribute("download", "tBirdwatcher Day Night.mp3");
      link.click();
    },
  },
};
</script>

<style scoped>
.wrapper {
  margin: 0 !important;
  height: 90%;
}
.full-width {
  max-width: none !important;
  padding: 0;
  width: 100% !important;
}
.white-bg {
  background-color: white;
  height: 100% !important;
  width: 100%;
  margin: auto;
}
.download-btn {
  border: 2px solid #92a2ff;
  width: 330px;
  stroke-width: 2px !important;
  align-self: center;
  height: 48px !important;
}
.download-btn p {
  font-style: normal;
  font-weight: bold;
  align-self: center;
  margin: auto;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-family: "MabryBold";
  color: #0b3530 !important;
}
h1 {
  font-family: "MabryRegular";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #000000;
  text-align: left;
}
</style>